import { Field, FormOptions } from "tinacms";
import { ABOUT_US_CONFIG } from "../common/lib/api/configs";

type FORM_RETURN_TYPE = FormOptions<ABOUT_US_CONFIG>;

const makeAboutUsForm = (
  data?: ABOUT_US_CONFIG,
  overrides?: Partial<FORM_RETURN_TYPE>
): FORM_RETURN_TYPE => {
  const empty = [] as Field[];
  const sectionCount = 5;
  const base = [] as NonNullable<FORM_RETURN_TYPE["fields"]>;
  return {
    id: "",
    label: "About us",
    onSubmit: console.log,
    initialValues: data,
    fields: [
      {
        name: "title",
        component: "text",
        label: "Titulo Hero",
      },
      {
        name: "subtitle",
        component: "textarea",
        label: "Subtítulo Hero",
      },
      ...base.concat(
        ...Array.from({ length: sectionCount }).map((_, i) => {
          return [
            {
              name: `sections[${i}].title`,
              component: "text",
              label: `Titulo seção ${i + 1}`,
            },
            {
              name: `sections[${i}].content`,
              component: "textarea",
              label: `Conteúdo seção ${i + 1}`,
            },
          ] as typeof base;
        })
      ),
      {
        name: "principles[0]",
        component: "textarea",
        label: "Missão",
      },
      {
        name: "principles[1]",
        component: "textarea",
        label: "Visão",
      },
      {
        name: "principles[2]",
        component: "textarea",
        label: "Valores",
      },
    ],
    ...overrides,
    onChange: console.log,
  };
};

export { makeAboutUsForm };
